module.exports = __webpack_public_path__ + "static/srinitya-b3f0d21ccb3e02f4b9a64290978671b7.png";